import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import type { InitOptions } from 'i18next';

// Import translations
import enTranslation from './locales/en/translation.json';
import esTranslation from './locales/es/translation.json';
import elTranslation from './locales/el/translation.json';
import itTranslation from './locales/it/translation.json';
import plTranslation from './locales/pl/translation.json';
import frTranslation from './locales/fr/translation.json';

const i18nConfig: InitOptions = {
  resources: {
    en: {
      translation: enTranslation
    },
    es: {
      translation: esTranslation
    },
    el: {
      translation: elTranslation
    },
    it: {
      translation: itTranslation
    },
    pl: {
      translation: plTranslation
    },
    fr: {
      translation: frTranslation
    }
  },
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false
  }
};

i18n
  .use(initReactI18next)
  .init(i18nConfig);

export default i18n; 